import { Box, Typography } from "@mui/material";
import { useNotify } from "react-admin";
import { typographySamples } from "./typographySamples";
import { TypographyUsageExamples } from "./TypographyUsageExamples";
import { BreadcrumbNav } from "../BreadCrumbNav";
import { TypographySampleCard } from "./TypographySampleCard";
import { AlertType } from "@/types";
import { useAppTheme } from "@/hooks/useAppTheme";

export const TypographyGuide = () => {
  const { theme } = useAppTheme();
  const notify = useNotify();

  const handleCopy = async (text: string) => {
    await navigator.clipboard.writeText(text);
    notify("Copied to clipboard!", { type: AlertType.SUCCESS });
  };

  return (
    <Box sx={{ p: 4, backgroundColor: theme.palette.background.default }}>
      <BreadcrumbNav current="Typography" />
      <Box mb={4}>
        <Typography variant="h1" gutterBottom>
          Typography
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Visual styles and usage guidance for headings, body, and label text.
        </Typography>
      </Box>

      {typographySamples.map((sample) => (
        <TypographySampleCard key={sample.variant} sample={sample} onCopy={handleCopy} />
      ))}

      <TypographyUsageExamples />
    </Box>
  );
};
